import { Component, inject, input, output } from '@angular/core';
import { UiModalComponent } from '../ui-modal/ui-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-confirmation-modal',
  imports: [UiModalComponent, TranslateModule],
  template: `
    <app-ui-modal
      [isOpen]="isOpen()"
      [title]="title()"
      [subtitle]="message()"
      (closed)="onCancel()"
    >
      <div class="m-deleteModal__content">
        <div class="m-deleteModal__actions">
          <button
            type="button"
            class="m-deleteModal__btn m-deleteModal__btn--cancel"
            (click)="onCancel()"
            [disabled]="isDeleting()"
          >
            {{ cancelLabel() }}
          </button>
          <button
            type="button"
            class="m-deleteModal__btn m-deleteModal__btn--delete"
            (click)="onConfirm()"
            [disabled]="isDeleting()"
          >
            {{ isDeleting() ? deletingLabel() : confirmLabel() }}
          </button>
        </div>
      </div>
    </app-ui-modal>
  `,
  styleUrl: './delete-confirmation-modal.component.scss',
})
export class DeleteConfirmationModalComponent {
  private translate = inject(TranslateService);

  isOpen = input.required<boolean>();
  title = input<string>(this.translate.instant('COMMON.DELETE_MODAL.TITLE'));
  message = input<string>(this.translate.instant('COMMON.DELETE_MODAL.MESSAGE'));
  itemName = input<string>();
  confirmLabel = input<string>(this.translate.instant('COMMON.DELETE_MODAL.CONFIRM'));
  cancelLabel = input<string>(this.translate.instant('COMMON.DELETE_MODAL.CANCEL'));
  deletingLabel = input<string>(this.translate.instant('COMMON.DELETE_MODAL.DELETING'));
  isDeleting = input<boolean>(false);

  confirmed = output<void>();
  cancelled = output<void>();

  onConfirm(): void {
    this.confirmed.emit();
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
